const initialState = () => ({
  clients: [],
})

const getters = {
  CLIENTS: state => state.clients,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_CLIENTS (state, payload) {
    state.clients = payload
  },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
